import { defineMessages } from 'react-intl'


export default defineMessages({
  description: {
    defaultMessage: 'Description',
    id: 'storage-disclosure-table.description',
  },
  domain: {
    defaultMessage: 'Domain',
    id: 'storage-disclosure-table.domain',
  },
  identifier: {
    defaultMessage: 'Identifier',
    id: 'storage-disclosure-table.identifier',
  },
  maxAge: {
    defaultMessage: 'Max Age',
    id: 'storage-disclosure-table.max-age',
  },
  optOut: {
    defaultMessage: 'Opt Out',
    id: 'storage-disclosure-table.opt-out',
  },
  specialPurposes: {
    defaultMessage: 'Special Purposes',
    id: 'storage-disclosure-table.special-purposes',
  },
  type: {
    defaultMessage: 'Type',
    id: 'storage-disclosure-table.type',
  },
})
